import type { CatalogItem } from "@/lib/services/catalog/catalog-types";

const types = [
  "drop", //+
  "collection", //+
  "oneofone", //+
  "installation",
  "physical", //+
  "immersive", //+
  "exhibition", //+
  "commission", //+
];

export const catalogItems: CatalogItem[] = [
  {
    id: 1,
    title:
      "Pulling focus can be tough with a bunch of water flying around... and you're super new to shooting video in general.",
    displayTitle: "Carpetdiem #131",
    filename: "PIPE-BLOWN-IN.MP4",
    tags: ["AI", "DIGITAL", "ORDINALS", "2023", "BITCOIN", "ONE OF ONE"],
    thumbnail: "/media/artwork-images/square.jpg",
    imageUrl: "/media/artwork-images/portrait_2.jpg",
    artist: "Mark Wilson",
    date: "2023-04-12",
    medium: "Digital Art / NFT",
    price: 4500,
    available: true,
    walletAddress: "0x1a2b3c4d5e6f7g8h9i0j1k2l3m4n5o6p7q8r9s0t",
    collections: ["Nature's Reflections", "Digital Abstracts"],
    year: 2023,
    description:
      "A DIGITAL ARTWORK EXPLORING THE CHALLENGES OF CAPTURING WATER MOTION IN VIDEOGRAPHY.",
    longDescription:
      "THIS PIECE REFLECTS THE ARTIST'S JOURNEY IN LEARNING VIDEO PRODUCTION, SPECIFICALLY THE DIFFICULTIES OF MAINTAINING FOCUS WHILE FILMING DYNAMIC WATER MOVEMENTS. THE WORK COMBINES TECHNICAL SKILL WITH ARTISTIC VISION, CREATING A MESMERIZING VISUAL EXPERIENCE.",
    dimensions: "1600 x 1600 px",
    location: "DIGITAL GALLERY",
    duration: "00:02:45",
    videoUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ",
    width: 1600,
    height: 1600,
    type: "collection",
  },
  {
    id: 2,
    title: "Revival of Aesthetics",
    displayTitle: "REVIVAL OF AESTHETICS",
    filename: "SISKIYOU-WALL.MP4",
    collections: ["Nature's Reflections", "Water Series"],
    tags: [
      "GENERATIVE ART",
      "DIGITAL",
      "SUPERRARE",
      "2024",
      "ETHEREUM",
      "INSTALLATION",
      "IMMERSIVE",
      "EXHIBITION",
    ],
    thumbnail: "/media/artwork-images/horizontal.jpg",
    year: 2024,
    description:
      "AN IMMERSIVE INSTALLATION THAT CREATES A VIRTUAL WALL OF WATER USING PROJECTION MAPPING AND SOUND DESIGN. THE INSTALLATION RESPONDS TO VIEWER MOVEMENT, CREATING A DYNAMIC AND EVER-CHANGING EXPERIENCE.",
    longDescription:
      "THIS SITE-SPECIFIC INSTALLATION TRANSFORMS THE EXHIBITION SPACE INTO AN IMMERSIVE ENVIRONMENT THAT EVOKES THE SENSATION OF STANDING BEFORE A POWERFUL WATERFALL. UTILIZING ADVANCED PROJECTION MAPPING TECHNIQUES AND SPATIAL AUDIO, THE WORK CREATES A MULTI-SENSORY EXPERIENCE THAT BLURS THE BOUNDARIES BETWEEN THE NATURAL AND THE DIGITAL.",
    dimensions: "VARIABLE (ADAPTS TO SPACE)",
    location: "GALLERY AND MUSEUM SPACES",
    duration: "CONTINUOUS LOOP (45 MINUTES)",
    videoUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ",
    imageUrl: "/media/artwork-images/horizontal.jpg",
    artist: "Sarah Chen",
    date: "2025-06-15",
    medium: "Generative Art / NFT",
    price: 3200,
    available: true,
    walletAddress: "0xbc4d3e6f7g8h9i0j1k2l3m4n5o6p7q8r9s0t1a2b3",
    width: 1920,
    height: 1080,
    type: "immersive",
  },
  {
    id: 3,
    title: "Transfigured Reality: Museum Solo Exhibition",
    displayTitle: "TRANSFIGURED REALITY",
    filename: "EXHIBITION-SPACE.MP4",
    tags: ["NEW MEDIA ART", "PHYSICAL", "EXHIBITION", "2024", "INSTALLATION"],
    thumbnail: "/media/artwork-images/portrait.jpg",
    imageUrl: "/media/artwork-images/portrait.jpg",
    artist: "OMA Studio",
    date: "2024-12-05",
    medium: "Exhibition / Installation",
    description:
      "A MAJOR SOLO EXHIBITION FEATURING A COLLECTION OF INTERACTIVE INSTALLATIONS AND DIGITAL ARTWORKS THAT EXPLORE THE INTERSECTION OF PHYSICAL AND VIRTUAL REALITY.",
    longDescription:
      "TRANSFIGURED REALITY IS A COMPREHENSIVE SOLO EXHIBITION THAT PRESENTS SEVEN DISTINCT INSTALLATIONS ACROSS THREE MUSEUM FLOORS. EACH INSTALLATION INVITES VIEWERS TO QUESTION THEIR PERCEPTION OF REALITY THROUGH INTERACTIVE TECHNOLOGIES, SPATIAL AUDIO, AND RESPONSIVE ENVIRONMENTS. THE EXHIBITION WILL TOUR INTERNATIONALLY FOLLOWING ITS INITIAL RUN.",
    dimensions: "VARIABLE (FULL MUSEUM)",
    location: "CONTEMPORARY ART MUSEUM",
    duration: "4 MONTHS",
    videoUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ",
    year: 2024,
    price: 25000,
    available: false,
    walletAddress: "0x5e6f7g8h9i0j1k2l3m4n5o6p7q8r9s0t1a2b3c4d",
    collections: ["Museum Exhibitions", "Interactive Installations"],
    width: 1144,
    height: 1600,
    type: "exhibition",
  },
  {
    id: 4,
    title: "Koa body womping his way out of one.",
    displayTitle: "Dream Garden",
    filename: "JWS LIVE SOON...MP4",
    tags: [
      "NEW MEDIA ART",
      "PHYGITAL",
      "FOUNDATION",
      "2022",
      "ETHEREUM",
      "UNIQUE",
      "PHYSICAL",
    ],
    thumbnail: "/media/artwork-images/portrait.jpg",
    imageUrl: "/media/artwork-images/portrait.jpg",
    artist: "Alex Johnson",
    date: "2025-03-01",
    medium: "Mixed Media / Physical + NFT",
    price: 6800,
    available: false,
    year: 2025,
    walletAddress: "0x3c4d5e6f7g8h9i0j1k2l3m4n5o6p7q8r9s0t1a2b",
    collections: ["Dream Series", "Physical NFTs"],
    description:
      "A MIXED MEDIA ARTWORK COMBINING PHYSICAL ELEMENTS WITH DIGITAL AUTHENTICATION, FEATURING DYNAMIC SURF IMAGERY.",
    longDescription:
      "DREAM GARDEN EXPLORES THE INTERSECTION OF PHYSICAL AND DIGITAL ART THROUGH A UNIQUE COMBINATION OF TRADITIONAL MEDIA AND BLOCKCHAIN TECHNOLOGY. THE PIECE CAPTURES THE FLUID MOTION OF A SURFER NAVIGATING THROUGH A CHALLENGING WAVE, SYMBOLIZING THE ARTIST'S JOURNEY THROUGH DIFFERENT ARTISTIC MEDIUMS.",
    dimensions: "60 x 90 CM (PHYSICAL) / 1144 x 1600 PX (DIGITAL)",
    location: "FOUNDATION GALLERY",
    duration: "00:01:35",
    videoUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ",
    width: 1144,
    height: 1600,
    type: "physical",
  },
  {
    id: 5,
    title: "Kaimana's first 10 point ride of the event.",
    displayTitle: "Latent Space #42",
    filename: "PIPE-KOA-BODYWO...MP4",
    tags: ["AI", "DIGITAL", "ARTBLOCKS", "2023", "ETHEREUM", "INSTALLATION"],
    thumbnail: "/media/artwork-images/vertical.jpg",
    imageUrl: "/media/artwork-images/vertical.jpg",
    artist: "Maria Rodriguez",
    date: "2023-07-22",
    medium: "AI-Generated Art / NFT",
    price: 2800,
    available: true,
    walletAddress: "0x7q8r9s0t1a2b3c4d3e6f7g8h9i0j1k2l3m4n5o6p",
    width: 1080,
    height: 1920,
    year: 2023,
    collections: ["Latent Space Series", "AI Generative Art"],
    description:
      "AN AI-GENERATED ARTWORK CAPTURING THE ESSENCE OF A PERFECT SURF RIDE, PART OF THE LATENT SPACE SERIES.",
    longDescription:
      "LATENT SPACE #42 UTILIZES ADVANCED MACHINE LEARNING ALGORITHMS TO INTERPRET AND REIMAGINE THE FLUID DYNAMICS OF OCEAN WAVES AND HUMAN MOVEMENT. THE PIECE CELEBRATES A HISTORIC MOMENT IN SURFING WHILE EXPLORING THE BOUNDARIES BETWEEN HUMAN ACHIEVEMENT AND COMPUTATIONAL CREATIVITY.",
    dimensions: "1080 x 1920 PX",
    location: "ARTBLOCKS GALLERY",
    duration: "00:03:15",
    videoUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ",
    type: "drop",
  },
  {
    id: 6,
    title: "A snippet of John John Florence's 3rd wave at Pipe.",
    displayTitle: "Digital Horizons #7",
    filename: "JJF-PIPE-3.MP4",
    tags: [
      "MOTION / ANIMATION",
      "DIGITAL",
      "FOUNDATION",
      "2024",
      "ETHEREUM",
      "COLLABORATION",
      "1/1",
    ],
    thumbnail: "/media/artwork-images/portrait_2.jpg",
    width: 1000,
    height: 1482,
    date: "2024-09-15",
    artist: "David Thompson",
    medium: "Motion Art / NFT",
    price: 3900,
    available: true,
    imageUrl: "/media/artwork-images/portrait_2.jpg",
    year: 2024,
    walletAddress: "0x9i0j1k2l3m4n5o6p7q8r9s0t1a2b3c4d5e6f7g8h",
    collections: ["Digital Horizons", "Surf Series"],
    description:
      "A MOTION ART PIECE CAPTURING THE FLUID DYNAMICS OF PROFESSIONAL SURFING AT PIPELINE.",
    longDescription:
      "DIGITAL HORIZONS #7 DOCUMENTS A PIVOTAL MOMENT IN JOHN JOHN FLORENCE'S PERFORMANCE AT PIPELINE. THE ARTWORK TRANSFORMS ATHLETIC PROWESS INTO DIGITAL POETRY, FREEZING MOMENTS OF PERFECT HARMONY BETWEEN HUMAN AND NATURE. EACH FRAME IS METICULOUSLY ENHANCED TO HIGHLIGHT THE POWER AND GRACE OF WORLD-CLASS SURFING.",
    dimensions: "1000 x 1482 PX",
    location: "FOUNDATION GALLERY",
    duration: "00:00:45",
    videoUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ",
    type: "commission",
  },
  {
    id: 7,
    title: "Tavi Gold's set at Waimea Bay during the winter swell.",
    displayTitle: "Quantum Bloom #18",
    filename: "TAVI-GOLD-SET.MP4",
    tags: [
      "GENERATIVE ART",
      "DIGITAL",
      "SUPERRARE",
      "2025",
      "ETHEREUM",
      "commission",
    ],
    thumbnail: "/media/artwork-images/wide.jpg",
    date: "2025-05-10",
    medium: "Generative Art / NFT",
    price: 5500,
    available: false,
    width: 3840,
    height: 1080,
    year: 2025,
    artist: "Lucas Wright",
    imageUrl: "/media/artwork-images/wide.jpg",
    walletAddress: "0x2b3c4d5e6f7g8h9i0j1k2l3m4n5o6p7q8r9s0t1a",
    collections: ["Quantum Bloom", "Winter Series"],
    description:
      "A GENERATIVE ART PIECE CAPTURING THE ENERGY OF WINTER SWELLS AT WAIMEA BAY.",
    longDescription:
      "QUANTUM BLOOM #18 USES ALGORITHMIC PROCESSES TO TRANSLATE THE POWER AND RHYTHM OF OCEAN WAVES INTO DIGITAL ART. THE PIECE COMMEMORATES TAVI GOLD'S LEGENDARY PERFORMANCE DURING THE WINTER SWELL, RENDERING THE NATURAL PHENOMENON THROUGH COMPUTATIONAL AESTHETICS. EACH VIEWING REVEALS NEW DETAILS IN THE COMPLEX PATTERNS.",
    dimensions: "3840 x 1080 PX",
    location: "SUPERRARE GALLERY",
    duration: "00:02:10",
    videoUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ",
    type: "commission",
  },
  {
    id: 8,
    title: "Sand pulled over the shoulder of a wave at Pipeline.",
    displayTitle: "Neural Wave",
    filename: "SAND-OVERTHESHO...MP4",
    tags: ["AI", "PHYGITAL", "ORDINALS", "2023", "BITCOIN"],
    thumbnail: "/media/artwork-images/vertical.jpg",
    width: 1080,
    height: 1920,
    date: "2023-11-28",
    artist: "Emma Lee",
    medium: "AI-Generated Art / NFT",
    price: 4200,
    available: true,
    imageUrl: "/media/artwork-images/vertical.jpg",
    year: 2023,
    walletAddress: "0x4d5e6f7g8h9i0j1k2l3m4n5o6p7q8r9s0t1a2b3c",
    collections: ["Neural Series", "Pipeline Collection"],
    description:
      "AN AI-GENERATED ARTWORK DEPICTING THE MESMERIZING INTERACTION OF SAND AND WATER AT PIPELINE.",
    longDescription:
      "NEURAL WAVE CAPTURES THE EPHEMERAL MOMENT WHEN SAND IS PULLED OVER THE SHOULDER OF A BREAKING WAVE AT PIPELINE. USING ADVANCED AI ALGORITHMS, THE ARTIST HAS TRANSFORMED THIS FLEETING NATURAL PHENOMENON INTO A HYPNOTIC DIGITAL EXPERIENCE THAT BLURS THE LINE BETWEEN PHOTOGRAPHY AND GENERATIVE ART.",
    dimensions: "1080 x 1920 PX",
    location: "ORDINALS GALLERY",
    duration: "00:01:25",
    videoUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ",
    type: "oneofone",
  },
  {
    id: 9,
    title: "Mason Ho clipping the lip at Pipe Masters.",
    displayTitle: "Chromatic Echo #5",
    filename: "PIPE-MASON-CLI.MP4",
    tags: ["CONTEMPORARY ART", "PHYSICAL", "ORDINALS", "2022", "BITCOIN"],
    thumbnail: "/media/artwork-images/square.jpg",
    width: 1600,
    height: 1600,
    date: "2022-08-05",
    artist: "Robert Kim",
    medium: "Physical Art + Digital Token",
    price: 7800,
    available: false,
    imageUrl: "/media/artwork-images/square.jpg",
    year: 2022,
    walletAddress: "0x6f7g8h9i0j1k2l3m4n5o6p7q8r9s0t1a2b3c4d5e",
    collections: ["Chromatic Echo", "Surf Masters"],
    description:
      "A PHYSICAL ARTWORK WITH DIGITAL AUTHENTICATION CAPTURING MASON HO'S ICONIC MOMENT AT PIPE MASTERS.",
    longDescription:
      "CHROMATIC ECHO #5 IMMORTALIZES A DEFINING MOMENT IN SURF HISTORY WHEN MASON HO EXECUTED A PERFECT LIP CLIP AT PIPE MASTERS. THE PHYSICAL ARTWORK IS PAIRED WITH A DIGITAL TOKEN ON THE BITCOIN BLOCKCHAIN, CREATING A UNIQUE COLLECTIBLE THAT BRIDGES TRADITIONAL AND DIGITAL ART WORLDS.",
    dimensions: "90 x 90 CM (PHYSICAL) / 1600 x 1600 PX (DIGITAL)",
    location: "PRIVATE COLLECTION",
    duration: "N/A",
    videoUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ",
    type: "physical",
  },
  {
    id: 10,
    title: "Aerial view of Pipeline surf break at sunset.",
    displayTitle: "Pixel Cascade #24",
    filename: "AERIAL-PIPE.MP4",
    tags: [
      "GENERATIVE ART",
      "DIGITAL",
      "ARTBLOCKS",
      "2024",
      "ETHEREUM",
      "COLLABORATION",
    ],
    thumbnail: "/media/artwork-images/horizontal.jpg",
    date: "2025-03-15",
    medium: "Generative Art / NFT",
    price: 4100,
    available: false,
    width: 1920,
    height: 1080,
    year: 2025,
    artist: "Thomas Chen",
    imageUrl: "/media/artwork-images/horizontal.jpg",
    walletAddress: "0x8h9i0j1k2l3m4n5o6p7q8r9s0t1a2b3c4d5e6f7g",
    collections: ["Pixel Cascade", "Aerial Series"],
    description:
      "A GENERATIVE ARTWORK CAPTURING THE ICONIC PIPELINE SURF BREAK FROM AN AERIAL PERSPECTIVE AT SUNSET.",
    longDescription:
      "PIXEL CASCADE #24 TRANSFORMS AERIAL FOOTAGE OF PIPELINE AT SUNSET INTO A MESMERIZING GENERATIVE ARTWORK. THE PIECE USES CUSTOM ALGORITHMS TO REINTERPRET THE NATURAL PATTERNS OF WAVES, LIGHT, AND SHADOW, CREATING A UNIQUE DIGITAL EXPERIENCE THAT EVOLVES WITH EACH VIEWING.",
    dimensions: "1920 x 1080 PX",
    location: "ARTBLOCKS GALLERY",
    duration: "00:02:30",
    videoUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ",
    type: "collection",
  },
  {
    id: 11,
    title: "Behind the scenes of the Volcom Pipe Pro.",
    displayTitle: "Fractal Dreams",
    filename: "BTS-VOLCOM.MP4",
    tags: ["NEW MEDIA ART", "DIGITAL", "FOUNDATION", "2023", "ETHEREUM"],
    thumbnail: "/media/artwork-images/portrait.jpg",
    width: 1144,
    height: 1600,
    date: "2023-06-20",
    artist: "Michael Chen",
    medium: "Digital Art / NFT",
    price: 3600,
    available: true,
    imageUrl: "/media/artwork-images/portrait.jpg",
    year: 2023,
    walletAddress: "0x0j1k2l3m4n5o6p7q8r9s0t1a2b3c4d5e6f7g8h9i",
    collections: ["Behind The Scenes", "Surf Documentary"],
    description:
      "A DIGITAL ARTWORK REVEALING THE UNSEEN MOMENTS OF THE VOLCOM PIPE PRO COMPETITION.",
    longDescription:
      "FRACTAL DREAMS OFFERS A RARE GLIMPSE INTO THE PREPARATION AND BACKSTAGE MOMENTS OF THE PRESTIGIOUS VOLCOM PIPE PRO SURFING COMPETITION. THE ARTWORK COMBINES DOCUMENTARY FOOTAGE WITH DIGITAL MANIPULATION TO CREATE A MULTI-LAYERED NARRATIVE ABOUT THE HUMAN EXPERIENCE BEHIND PROFESSIONAL SURFING.",
    dimensions: "1144 x 1600 PX",
    location: "FOUNDATION GALLERY",
    duration: "00:03:45",
    videoUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ",
    type: "oneofone",
  },
  {
    id: 12,
    title: "Kelly Slater's winning wave at Pipeline.",
    displayTitle: "Digital Genesis #9",
    filename: "KELLY-PIPE.MP4",
    tags: ["CONTEMPORARY ART", "PHYSICAL", "OTHER", "2021", "ETHEREUM"],
    thumbnail: "/media/artwork-images/square.jpg",
    width: 1600,
    height: 1600,
    date: "2021-12-10",
    artist: "Jennifer Park",
    medium: "Mixed Media / Physical",
    price: 8500,
    available: false,
    imageUrl: "/media/artwork-images/square.jpg",
    year: 2021,
    walletAddress: "0x1k2l3m4n5o6p7q8r9s0t1a2b3c4d5e6f7g8h9i0j",
    collections: ["Digital Genesis", "Surf Legends"],
    description:
      "A MIXED MEDIA ARTWORK COMMEMORATING KELLY SLATER'S HISTORIC WINNING WAVE AT PIPELINE.",
    longDescription:
      "DIGITAL GENESIS #9 CELEBRATES ONE OF THE MOST ICONIC MOMENTS IN SURFING HISTORY - KELLY SLATER'S WINNING WAVE AT PIPELINE. THE ARTWORK COMBINES TRADITIONAL MEDIA WITH DIGITAL ELEMENTS TO CREATE A TIMELESS TRIBUTE TO SLATER'S MASTERY OF THE SPORT AND HIS ENDURING LEGACY IN SURF CULTURE.",
    dimensions: "120 x 120 CM",
    location: "PRIVATE COLLECTION",
    duration: "00:01:15",
    videoUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ",
    type: "physical",
  },
  {
    id: 13,
    title: "Morning light at Off The Wall.",
    displayTitle: "Nebula Drift",
    filename: "OTW-MORNING.MP4",
    tags: ["MOTION / ANIMATION", "PHYGITAL", "SUPERRARE", "2025", "ETHEREUM"],
    thumbnail: "/media/artwork-images/vertical.jpg",
    date: "2025-04-22",
    medium: "Motion Art / NFT",
    price: 7200,
    available: false,
    width: 1080,
    height: 1920,
    year: 2025,
    artist: "Olivia Martinez",
    imageUrl: "/media/artwork-images/vertical.jpg",
    walletAddress: "0x2l3m4n5o6p7q8r9s0t1a2b3c4d5e6f7g8h9i0j1k",
    collections: ["Nebula Series", "Morning Light"],
    description:
      "A MOTION ART PIECE CAPTURING THE ETHEREAL MORNING LIGHT AT OFF THE WALL SURF BREAK.",
    longDescription:
      "NEBULA DRIFT TRANSFORMS THE TRANQUIL MORNING LIGHT AT OFF THE WALL INTO A MESMERIZING DIGITAL EXPERIENCE. THE ARTWORK PLAYS WITH LIGHT, SHADOW, AND MOVEMENT TO CREATE A HYPNOTIC VISUAL NARRATIVE THAT EVOKES THE PEACEFUL ENERGY OF DAWN AT ONE OF HAWAII'S MOST ICONIC SURF SPOTS.",
    dimensions: "1080 x 1920 PX",
    location: "SUPERRARE GALLERY",
    duration: "00:02:35",
    videoUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ",
    type: "oneofone",
  },
  {
    id: 14,
    title: "Digital Metamorphosis",
    displayTitle: "Digital Metamorphosis",
    filename: "METAMORPHOSIS-2025.MP4",
    tags: ["DIGITAL ART", "NFT", "FOUNDATION", "2025", "ETHEREUM"],
    thumbnail: "/media/artwork-images/square.jpg",
    date: "2025-05-15",
    medium: "Digital Art / NFT",
    price: 5800,
    available: true,
    width: 2000,
    height: 2000,
    year: 2025,
    artist: "Daniel Walker",
    imageUrl: "/media/artwork-images/square.jpg",
    walletAddress: "0x3m4n5o6p7q8r9s0t1a2b3c4d5e6f7g8h9i0j1k2l",
    collections: ["Metamorphosis Series", "Digital Evolution"],
    description:
      "A DIGITAL ARTWORK EXPLORING THE CONCEPT OF TRANSFORMATION IN THE DIGITAL AGE.",
    longDescription:
      "DIGITAL METAMORPHOSIS EXAMINES THE EVER-CHANGING NATURE OF DIGITAL IDENTITY AND EXPRESSION. THE ARTWORK USES GENERATIVE ALGORITHMS TO CREATE A CONSTANTLY EVOLVING VISUAL NARRATIVE THAT MIRRORS THE TRANSFORMATIVE NATURE OF TECHNOLOGY AND ITS IMPACT ON HUMAN EXPERIENCE.",
    dimensions: "2000 x 2000 PX",
    location: "FOUNDATION GALLERY",
    duration: "00:04:20",
    videoUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ",
    type: "drop",
  },
  {
    id: 15,
    title: "Cosmic Resonance",
    displayTitle: "Cosmic Resonance",
    filename: "COSMIC-RES-2024.JPG",
    tags: ["CONTEMPORARY ART", "PHYSICAL", "GALLERY", "2024", "ETHEREUM"],
    thumbnail: "/media/artwork-images/horizontal.jpg",
    date: "2024-11-30",
    medium: "Acrylic on Canvas",
    price: 12500,
    available: true,
    width: 1920,
    height: 1080,
    year: 2024,
    artist: "Sophia Chang",
    imageUrl: "/media/artwork-images/horizontal.jpg",
    walletAddress: "0x4n5o6p7q8r9s0t1a2b3c4d5e6f7g8h9i0j1k2l3m",
    collections: ["Cosmic Series", "Contemporary Abstracts"],
    description:
      "A CONTEMPORARY ARTWORK EXPLORING THE RESONANCE BETWEEN COSMIC FORCES AND HUMAN PERCEPTION.",
    longDescription:
      "COSMIC RESONANCE DELVES INTO THE MYSTERIOUS CONNECTIONS BETWEEN CELESTIAL PHENOMENA AND HUMAN CONSCIOUSNESS. THROUGH BOLD BRUSHSTROKES AND A VIBRANT COLOR PALETTE, THE ARTWORK CREATES A VISUAL SYMPHONY THAT INVITES VIEWERS TO CONTEMPLATE THEIR PLACE IN THE UNIVERSE AND THE UNSEEN FORCES THAT SHAPE OUR REALITY.",
    dimensions: "150 x 100 CM",
    location: "CONTEMPORARY ART GALLERY",
    duration: "N/A",
    videoUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ",
    type: "exhibition",
  },
  {
    id: 16,
    title: "Urban Fragments",
    displayTitle: "Urban Fragments",
    filename: "URBAN-FRAG-2024.MP4",
    tags: ["MOTION / ANIMATION", "NFT", "OPENSEA", "2024", "POLYGON"],
    thumbnail: "/media/artwork-images/vertical.jpg",
    date: "2024-08-17",
    medium: "Motion Art / NFT",
    price: 3200,
    available: true,
    width: 1080,
    height: 1920,
    year: 2024,
    artist: "Marcus Johnson",
    imageUrl: "/media/artwork-images/vertical.jpg",
    walletAddress: "0x5o6p7q8r9s0t1a2b3c4d5e6f7g8h9i0j1k2l3m4n",
    collections: ["Urban Series", "City Fragments"],
    description:
      "A MOTION ART PIECE EXPLORING THE FRAGMENTARY NATURE OF URBAN ENVIRONMENTS.",
    longDescription:
      "URBAN FRAGMENTS DECONSTRUCTS AND RECOMPOSES THE VISUAL ELEMENTS OF CITY LIFE, CREATING A KALEIDOSCOPIC JOURNEY THROUGH METROPOLITAN SPACES. THE ARTWORK EXAMINES HOW URBAN ENVIRONMENTS ARE EXPERIENCED AS DISCONNECTED MOMENTS AND IMPRESSIONS, CHALLENGING VIEWERS TO REASSEMBLE THESE FRAGMENTS INTO A COHERENT NARRATIVE OF CONTEMPORARY URBAN EXISTENCE.",
    dimensions: "1080 x 1920 PX",
    location: "OPENSEA GALLERY",
    duration: "00:03:15",
    videoUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ",
    type: "collection",
  },
  {
    id: 17,
    title: "Ethereal Landscapes",
    displayTitle: "Ethereal Landscapes",
    filename: "ETHEREAL-2025.JPG",
    tags: ["DIGITAL ART", "PHYGITAL", "GALLERY", "2025", "SOLANA"],
    thumbnail: "/media/artwork-images/square.jpg",
    date: "2025-01-22",
    medium: "Mixed Media / Digital Print",
    price: 9200,
    available: false,
    width: 2400,
    height: 2400,
    year: 2025,
    artist: "Elena Petrova",
    imageUrl: "/media/artwork-images/square.jpg",
    walletAddress: "0x6p7q8r9s0t1a2b3c4d5e6f7g8h9i0j1k2l3m4n5o",
    collections: ["Ethereal Series", "Digital Landscapes"],
    description:
      "A MIXED MEDIA ARTWORK EXPLORING THE BOUNDARY BETWEEN PHYSICAL AND DIGITAL LANDSCAPES.",
    longDescription:
      "ETHEREAL LANDSCAPES BLURS THE LINE BETWEEN TANGIBLE AND VIRTUAL ENVIRONMENTS, CREATING DREAMLIKE VISTAS THAT EXIST IN BOTH REALMS SIMULTANEOUSLY. THE ARTWORK COMBINES TRADITIONAL PAINTING TECHNIQUES WITH DIGITAL MANIPULATION, RESULTING IN A HYBRID CREATION THAT CHALLENGES OUR PERCEPTION OF REALITY AND QUESTIONS THE NATURE OF ARTISTIC EXPERIENCE IN THE DIGITAL AGE.",
    dimensions: "100 x 100 CM (PHYSICAL) / 2400 x 2400 PX (DIGITAL)",
    location: "CONTEMPORARY GALLERY",
    duration: "N/A",
    videoUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ",
    type: "drop",
  },
  {
    id: 18,
    title: "Quantum Reflections",
    displayTitle: "Quantum Reflections",
    filename: "QUANTUM-REFL-2024.MP4",
    tags: ["MOTION / ANIMATION", "NFT", "SUPERRARE", "2024", "ETHEREUM"],
    thumbnail: "/media/artwork-images/horizontal.jpg",
    date: "2024-12-05",
    medium: "Generative Art / NFT",
    price: 6500,
    available: true,
    width: 1920,
    height: 1080,
    year: 2024,
    artist: "Julia Kim",
    imageUrl: "/media/artwork-images/horizontal.jpg",
    walletAddress: "0x7q8r9s0t1a2b3c4d5e6f7g8h9i0j1k2l3m4n5o6p",
    collections: ["Quantum Series", "Reflective Landscapes"],
    description:
      "A GENERATIVE ARTWORK EXPLORING THE REFLECTIVE QUALITIES OF QUANTUM SYSTEMS.",
    longDescription:
      "QUANTUM REFLECTIONS USES ALGORITHMIC PROCESSES TO CREATE A DYNAMIC AND IMMERSIVE ENVIRONMENT THAT REFLECTS THE INTRICACIES OF QUANTUM MECHANICS. THE ARTWORK INVITES VIEWERS TO EXPLORE THE BOUNDARIES BETWEEN REALITY AND REFLECTION, CHALLENGING OUR UNDERSTANDING OF THE PHYSICAL WORLD AND ITS REPRESENTATION IN DIGITAL SPACE.",
    dimensions: "1920 x 1080 PX",
    location: "SUPERRARE GALLERY",
    duration: "00:03:20",
    videoUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ",
    type: "exhibition",
  },
  {
    id: 19,
    title: "Synthetic Dreams",
    displayTitle: "Synthetic Dreams",
    filename: "SYNTHETIC-DREAMS-2025.JPG",
    tags: ["CONTEMPORARY ART", "PHYSICAL", "GALLERY", "2025", "OTHER"],
    thumbnail: "/media/artwork-images/square.jpg",
    date: "2025-02-18",
    medium: "Oil on Canvas",
    price: 15000,
    available: true,
    width: 1500,
    height: 1500,
    year: 2025,
    artist: "Daniel Lee",
    imageUrl: "/media/artwork-images/square.jpg",
    walletAddress: "0x8h9i0j1k2l3m4n5o6p7q8r9s0t1a2b3c4d5e6f7g",
    collections: ["Synthetic Series", "Dreamscapes"],
    description:
      "A CONTEMPORARY ARTWORK EXPLORING THE BOUNDARY BETWEEN REALITY AND SYNTHETIC EXPERIENCE.",
    longDescription:
      "SYNTHETIC DREAMS DELVES INTO THE WORLD OF SYNTHETIC REALITY, CREATING A DREAMLIKE ATMOSPHERE THAT CHALLENGES VIEWERS TO DISTINGUISH BETWEEN THE PHYSICAL AND THE DIGITAL. THE ARTWORK USES TRADITIONAL PAINTING TECHNIQUES TO EXPLORE THE EMERGENCE OF NEW FORMS OF REALITY AND THEIR IMPACT ON HUMAN PERCEPTION.",
    dimensions: "120 x 120 CM",
    location: "CONTEMPORARY GALLERY",
    duration: "N/A",
    videoUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ",
    type: "collection",
  },
  {
    id: 20,
    title: "Neon Wilderness",
    displayTitle: "Neon Wilderness",
    filename: "NEON-WILD-2025.MP4",
    tags: ["DIGITAL ART", "NFT", "FOUNDATION", "2025", "ETHEREUM", "INSTALLATION"],
    thumbnail: "/media/artwork-images/vertical.jpg",
    date: "2025-06-10",
    medium: "Digital Art / NFT",
    price: 4800,
    available: true,
    width: 1080,
    height: 1920,
    year: 2025,
    artist: "Emily Patel",
    imageUrl: "/media/artwork-images/vertical.jpg",
    walletAddress: "0x9i0j1k2l3m4n5o6p7q8r9s0t1a2b3c4d5e6f7g8h",
    collections: ["Neon Series", "Wilderness Explorations"],
    description:
      "A DIGITAL ARTWORK EXPLORING THE INTERSECTION OF NATURE AND TECHNOLOGY.",
    longDescription:
      "NEON WILDERNESS CREATES A DREAMLIKE ENVIRONMENT THAT COMBINES THE BEAUTY OF NATURE WITH THE GLOW OF NEON LIGHTS. THE ARTWORK USES GENERATIVE ALGORITHMS TO CREATE A UNIQUE AND IMMERSIVE EXPERIENCE THAT INVITES VIEWERS TO EXPLORE THE BOUNDARIES BETWEEN THE NATURAL AND THE DIGITAL.",
    dimensions: "1080 x 1920 PX",
    location: "FOUNDATION GALLERY",
    duration: "00:02:50",
    videoUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ",
    type: "installation",
  },
];

// Helper function to get all unique tags from artworks
export const getAllUniqueTags = (): string[] => {
  return Array.from(
    new Set(catalogItems.flatMap((artwork) => artwork.tags))
  ).sort();
};
